/**
 * Frontend logger utility that provides consistent logging interface
 */
class Logger {
  info(...args: any): void {
    // eslint-disable-next-line no-console
    console.log(...args);
  }

  error(...args: any): void {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}

const logger = new Logger();

export default logger;
